import { useEffect, useState } from 'react'
import api from '../utils/api'

const useUpdatePassword = (email, code, password, submit) => {
  const [updatePasswordRequest, setUpdatePasswordRequest] = useState({
    data: null,
    isLoading: false,
    error: null,
  })

  useEffect(() => {
    setUpdatePasswordRequest((currentUpdatePasswordRequest) => ({
      ...currentUpdatePasswordRequest,
      isLoading: false,
      error: null,
    }))

    async function login() {
      if (email && code && password && submit) {
        try {
          setUpdatePasswordRequest((currentUpdatePasswordRequest) => ({
            ...currentUpdatePasswordRequest,
            isLoading: true,
            error: null,
          }))
          const response = await api.put(
            '/updatePassword',
            { email, code, password },
            { includeToken: false }
          )
          setUpdatePasswordRequest({
            data: response.data,
            isLoading: false,
            error: null,
          })
        } catch (error) {
          setUpdatePasswordRequest({ data: null, isLoading: false, error })
        }
      }
    }
    login()
  }, [email, code, password, submit])

  return updatePasswordRequest
}

export default useUpdatePassword
